// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1iiav","title":"AfterBackImages_title__1SX4g","images":"AfterBackImages_images__2Ccgz"};